/* @ngInject */
export default function ($scope, LayoutService, Forms, toastr, $state, AuthService, PermissionsGates, PermissionsCategories, PermissionsUsers, PermissionsServiceUsers, $q) {
	AuthService.redirectIfUnauthorized('forms-management-view', 'splash.home');

	$scope.loading = true;

	$scope.recipients = [];

	$scope.permissionTypes = {
		'gate':        'Gate',
		'category':    'Category',
		'user':        'User',
		'serviceUser': 'Service User',
		'public':      'Public Access',
	};

	$scope.form = {
		title:                    '',
		description:              '',
		completionPermissions:    [],
		viewResponsesPermissions: [],
		recipientEmails:          [],
	};

	$scope.refresh = () => {
		$scope.loading = true;

		$q.all([
			PermissionsGates.getList(),
			PermissionsCategories.getList(),
			PermissionsUsers.getList({
				include: 'workable',
			}),
			PermissionsServiceUsers.getList(),
		])
		  .then((results) => {
			  const permissionsGates        = results[0];
			  const permissionsCategories   = results[1];
			  const permissionsUsers        = results[2];
			  const permissionsServiceUsers = results[3];

			  const statusGroups = {
				  0: 'Inactive',
				  1: 'Active',
				  2: 'Finished',
			  };

			  $scope.permissionsGates        = permissionsGates;
			  $scope.permissionsCategories   = permissionsCategories;
			  $scope.permissionsUsers        = permissionsUsers;
			  $scope.permissionsServiceUsers = permissionsServiceUsers.map((serviceUser) => {
				  return {
					  ...serviceUser,
					  shortCode:   (serviceUser.shortCode) ? ('SU#' + serviceUser.shortCode) : ('N/A'),
					  statusGroup: statusGroups[serviceUser.status],
				  };
			  });

			  $scope.loading = false;
		  })
		  .catch((error) => {
			  toastr.clear();
			  toastr.error('There was an error while loading this page, please try again.', 'Error');

			  $state.go('staff.forms.management.root');
		  });
	};

	$scope.save = () => {
		const form = {
			title:                    $scope.form.title,
			description:              $scope.form.description,
			completionPermissions:    $scope.form.completionPermissions.filter((permission) => {
				switch (permission.type) {
					case 'gate': {
						return permission.gate;
					}

					case 'category': {
						return permission.category;
					}

					case 'user': {
						return permission.user;
					}

					case 'serviceUser': {
						return permission.serviceUser;
					}

					case 'public': {
						return true;
					}

					default: {
						return false;
					}
				}
			}),
			viewResponsesPermissions: $scope.form.viewResponsesPermissions.filter((permission) => {
				switch (permission.type) {
					case 'gate': {
						return permission.gate;
					}

					case 'category': {
						return permission.category;
					}

					case 'user': {
						return permission.user;
					}

					case 'serviceUser': {
						return permission.serviceUser;
					}

					case 'public': {
						return true;
					}

					default: {
						return false;
					}
				}
			}),
			recipientEmails:          $scope.recipients.map((recipient) => {
				return (recipient.email) ? (recipient.email) : (null);
			})
			                                .filter((email) => {
				                                return (email);
			                                }),
		};

		Forms.post(form)
		     .then((returnedForm) => {
			     toastr.clear();
			     toastr.success('The form was successfully saved.', 'Form Saved');

			     $state.go('staff.forms.management.root');
		     })
		     .catch((error) => {
			     toastr.clear();
			     toastr.error('There was an error while updating the form, please try again.', 'Error');
		     });
	};

	$scope.addRecipient = () => {
		$scope.recipients.push({
			'user':  '',
			'email': '',
		});
	};

	$scope.removeRecipient = (index) => {
		$scope.recipients.splice(index, 1);
	};

	$scope.selectedRecipientUser = (index) => {
		let email = '';

		const userId = $scope.recipients[index].user;

		let user = (userId) ? ($scope.permissionsUsers.find((user) => {
			return user.id === userId;
		})) : (null);

		if (user) {
			email = user.workable.email;
		}

		$scope.recipients[index].email = email;
	};

	$scope.addCompletionPermission = () => {
		$scope.form.completionPermissions.push({
			type:        '',
			gate:        null,
			category:    null,
			user:        null,
			serviceUser: null,
		});
	};

	$scope.removeCompletionPermission = (index) => {
		$scope.form.completionPermissions.splice(index, 1);
	};

	$scope.resetCompletionPermission = (index) => {
		$scope.form.completionPermissions[index] = {
			...$scope.form.completionPermissions[index],
			gate:        null,
			category:    null,
			user:        null,
			serviceUser: null,
		};
	};

	$scope.addViewResponsesPermission = () => {
		$scope.form.viewResponsesPermissions.push({
			type:        '',
			gate:        null,
			category:    null,
			user:        null,
			serviceUser: null,
		});
	};

	$scope.removeViewResponsesPermission = (index) => {
		$scope.form.viewResponsesPermissions.splice(index, 1);
	};

	$scope.resetViewResponsesPermission = (index) => {
		$scope.form.viewResponsesPermissions[index] = {
			...$scope.form.viewResponsesPermissions[index],
			gate:        null,
			category:    null,
			user:        null,
			serviceUser: null,
		};
	};

	$scope.updateLayout = () => {
		LayoutService.reset();

		LayoutService.setTitle([
			'New Form',
			'Management',
			'Forms',
		]);

		LayoutService.getPageHeader()
		             .setBreadcrumbs([
			             {
				             route:       'staff.dashboard',
				             displayName: 'Dashboard',
			             },
			             {
				             route:       'staff.forms.root',
				             displayName: 'Forms',
			             },
			             {
				             route:       'staff.forms.management.root',
				             displayName: 'Management',
			             },
			             {
				             route:       `staff.forms.management.new`,
				             displayName: 'New Form',
			             },
		             ]);

		const updateButton = LayoutService.getPageHeader()
		                                  .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-sync-alt"></i> Update</button>');

		const saveButton = LayoutService.getPageHeader()
		                                .setActionButton('<button type="button" class="btn btn-primary pull-right m-r-sm"><i class="fa fa-check"></i> Save</button>');

		LayoutService.getPageHeader()
		             .onClicked(updateButton, $scope.refresh);

		LayoutService.getPageHeader()
		             .onClicked(saveButton, $scope.save);
	};

	$scope.updateLayout();
	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/forms/management/new/controller.js